module.exports = __webpack_public_path__ + "assets/404-bg-0.5x.e64af838.png";